import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import useActions, { useAppSelector } from "../../app/hooks";
import { selectFolders } from "../library/librarySlice";
import { Folder } from "../../types/Folder";

export default function CreateScenarioForm(props: {
  open: boolean;
  parentCloseHandle: () => void;
}) {
  const actions = useActions();
  const folders = useAppSelector(selectFolders) as Folder[];

  const [name, setName] = useState("");
  const [nameError, setNameError] = React.useState("");
  const [folderId, setFolderId] = useState<number | "">("");
  const [priority, setPriority] = useState<number>(0);

  function createScenario() {
    actions.createScenario({
      name,
      parent_scenario_id: -1,
      folder_id: folderId === "" ? null : (folderId as number),
      priority,
    });
    props.parentCloseHandle();
  }

  function handleNameChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value.trim() === "") {
      setNameError("Invalid name");
    } else {
      setNameError("");
    }
    setName(e.target.value);
  }

  return (
    <Dialog open={props.open} onClose={() => props.parentCloseHandle()}>
      <DialogTitle>New Scenario</DialogTitle>
      <DialogContent>
        <DialogContentText>Create a new scenario</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Name"
          error={nameError !== ""}
          fullWidth
          variant="standard"
          value={name}
          onChange={handleNameChange}
        />
        <TextField
          margin="dense"
          id="priority"
          label="Priority"
          type="number"
          fullWidth
          variant="standard"
          value={priority}
          onChange={(e) => setPriority(Number(e.target.value))}
          inputProps={{ step: 1, min: 0 }}
        />
        <FormControl fullWidth margin="dense" variant="standard">
          <InputLabel id="create-scenario-folder-label">Folder</InputLabel>
          <Select
            labelId="create-scenario-folder-label"
            value={folderId}
            onChange={(e) => setFolderId(e.target.value === "" ? "" : (e.target.value as number))}
            label="Folder"
          >
            <MenuItem value="">None</MenuItem>
            {folders.map((f) => (
              <MenuItem key={f.id} value={f.id}>
                {f.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.parentCloseHandle()}>Cancel</Button>
        <Button
          onClick={createScenario}
          type="submit"
          variant="contained"
          color="primary"
          disabled={nameError !== "" || name.trim() === ""}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
